import React from "react";
import { Card, Col, FormGroup, Nav, NavItem, NavLink, Row } from 'reactstrap'
import { Link } from 'react-router-dom'
import { PlusSquare } from 'react-feather'
import { ProjectListNavProps } from '../../../../Types/Project.type'
import { CreateBookReviewTemplateTitle, Href, } from '../../../../Utils/Constants'
import { reviewTemplateListNavList } from '../../../../Data/Applications/Project'
import Authorized from '../../../../CommonElements/Authorisation/Authorise'

/** helper to create a safe slug for data-tour attributes */
const slugify = (s?: string) =>
  (s || '')
    .toLowerCase()
    .replace(/\s+/g, '-')       // spaces -> dashes
    .replace(/[^\w-]+/g, '')   // remove non-word chars
    .replace(/--+/g, '-')      // collapse multiple dashes
    .replace(/^-+|-+$/g, '');  // trim leading/trailing dashes

export default function ReviewListNav({ activeTab, setActiveTab }: ProjectListNavProps) {
    return (
        <Card>
            <Row>
                <Col md={6}>
                    {/* main tour target for the tabs row */}
                    <Nav className="border-tab" tabs data-tour="review-list-tabs">
                        {reviewTemplateListNavList.map((item) => {
                            const tabDataTour = `review-tab-${slugify(item.text)}`; // e.g. review-tab-upcoming
                            return (
                                <NavItem key={item.id}>
                                    <NavLink
                                        href={Href}
                                        className={activeTab === item.id ? "active" : ""}
                                        onClick={() => { setActiveTab(item.id) }}
                                        // per-tab target (optional, useful for per-tab tour steps)
                                        data-tour={tabDataTour}
                                    >
                                        {item.icon}{item.text}
                                    </NavLink>
                                </NavItem>
                            );
                        })}
                    </Nav>
                </Col>
                <Authorized allowed={['admin', 'group leader']}>
                <Col md={6} className='d-md-block d-none'>
                    <FormGroup className="mb-0 me-0">
                        <Link className="btn btn-primary d-flex align-items-center" to={`${process.env.PUBLIC_URL}/book_review/create`}>
                            <PlusSquare /> {CreateBookReviewTemplateTitle}
                        </Link>
                    </FormGroup>
                </Col>
                </Authorized>
            </Row>
        </Card>
    )
}
